
import classNames from "classnames";
import Link from "next/link";
import { type ReactNode } from "react";
import styles from "./PosterContainerLink.module.css";

//#region [Props]
type PosterContainerLinkProps = {
    children: ReactNode;
    href?: string | null;
    className?: string;
};
//#endregion

//#region [Component]
export default function PosterContainerLink({ children, href, className }: PosterContainerLinkProps) {
    if (href) {
        return <Link href={href} className={classNames(styles.PosterContainerLink, className)}>{children}</Link>;
    }
    return <div className={classNames(styles.PosterContainerLink, className)}>{children}</div>
}
//#endregion

//#region [Styles]

//#endregion